import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchDataFromTable,
  uploadNewRecord,
} from "../../services/assortment_management/actions";
import { BackModal } from "../BackModal";

export default function TableEntry(props) {
  const [tableContent, setTableContent] = useState([]);
  const [filteredFields, setFilteredFields] = useState([]);
  const params = useParams();
  let navigate = useNavigate();

  const [uploadData, setUploadData] = useState({});

  const updateData = (name, value) => {
    setUploadData({
      ...uploadData,
      [name]: value,
    });
    console.dir(uploadData);
  };

  const submit = (e) => {
    e.preventDefault();
    console.log(uploadData);
    uploadNewRecord(params.table, uploadData).then((res) => {
      if (res) {
        navigate(`/assortment-management/${params.table}`);
      }
    });
  };

  useEffect(() => {
    fetchDataFromTable(params.table).then((res) => {
      setTableContent(res);
    });
    setFilteredFields(
      props.dataModel?.filter((table) => table.name === params.table)[0]
        .description.fields
    );
  }, [props.dataModel]);

  const generateForm = (fields) => {
    switch (fields.widget) {
      case "checkbox":
        return (
          <div style={{ display: "flex", order: 1 }}>
            <label>
              {fields.label}:
              <input
                type="checkbox"
                name={fields.label}
                onChange={(e) => updateData(fields.label, e.target.checked)}
                required={fields.not_null}
              />
            </label>
          </div>
        );

      case "text":
        return (
          <div style={{ display: "flex", order: 2 }}>
            <label>
              {fields.label}:{" "}
              <input
                style={{ display: "flex", alignItems: "flex-end" }}
                type="text"
                name={fields.label}
                onChange={(e) => updateData(fields.label, e.target.value)}
                required={fields.not_null}
              />
            </label>
          </div>
        );

      case "textarea":
        return (
          <div style={{ display: "flex", order: 2 }}>
            <label>
              {fields.label}:{" "}
              <textarea
                style={{ display: "flex", alignItems: "flex-end" }}
                type="text"
                name={fields.label}
                onChange={(e) => updateData(fields.label, e.target.value)}
                required={fields.not_null}
              />
            </label>
          </div>
        );

      case "number":
        return (
          <div style={{ display: "flex", order: 3 }}>
            <label>
              {fields.label}:
              <input
                type="number"
                name={fields.label}
                onChange={(e) => updateData(fields.label, e.target.value)}
                required={fields.not_null}
              />
            </label>
          </div>
        );

      case "radio":
        return (
          <div style={{ display: "flex", order: 4 }}>
            <label>{fields.label}</label>
            {Object.keys(fields.choices).map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  name={fields.label}
                  id={option}
                  onChange={(e) =>
                    updateData(fields.label, fields.choices[option])
                  }
                  required={fields.not_null}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
        );

      case "select":
        return (
          <>
            <label style={{ marginRight: "5px" }}>{fields.label}</label>

            <select
              style={{ width: "150px" }}
              //defaultValue={"none"}
              onChange={(e) => updateData(fields.label, e.target.value)}
              required={fields.not_null}
            >
              <option value="" selected disabled>
                Maak een keuze...
              </option>
              {fields.options.map((option) => (
                <>
                  <option value={option.value} name={fields.label}>
                    {option.option}
                  </option>
                </>
              ))}
            </select>
          </>
        );

      default:
        break;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "column",
      }}
    >
      <BackModal />
      <form onSubmit={submit}>
        {filteredFields?.map(
          (component) =>
            // <div
            // 	style={{
            // 		display: "flex",
            // 		margin: "4px",
            // 		justifyContent: "center",
            // 		//maxWidth: "80vw",
            // 		alignContent: "center",
            // 	}}
            // >
            generateForm(component, tableContent)
          /* </div> */
        )}
        <button>Submit</button>
      </form>
    </div>
  );
}
